<template>
  <b-modal
    @ok="onOkClick"
    @cancel="onCancelClick"
    @show="onModalShow"
    id="createFromKkeDialog"
    title="VE aus KKE erzeugen"
    centered
    okTitle="Bestätigen"
    cancelTitle="Abbrechen"
    okVariant="danger"
  >
    <div class="mb-2">Sollen die Vergabeeinheiten wirklich aus den Kostenkontrolleinheiten erzeugt werden?</div>
    <strong>Präfix:</strong>
    <small class="text-muted">&nbsp;&nbsp;(wird vor alle Ve-Nr. ergänzt)</small>
    <b-input v-model.lazy="prefix" autofocus />
    <div class="mt-3">
      <strong>Hinweis:</strong>
      <br />
      <li>Bestehende Budgetzuordnungen werden gelöscht.</li>
      <li>Bestehende VE Bezeichnungen werden überschrieben.</li>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      prefix: ''
    };
  },
  methods: {
    onModalShow() {},
    onOkClick() {
      this.$emit('ok', this.prefix);
    },
    onCancelClick() {
      this.$emit('cancel');
    }
  }
};
</script>

<style></style>
